import CardClient from "components/CardClient";
import { hiddenCardNumber } from "utils/mask";
import LimiteDisponivel from "../LimiteDisponivel/LimiteDisponivel";
import { TIPO_CARTAO_CONVENIO, TIPO_CARTAO_TEUCARD, TipoCartao } from "models/tipoCartao";

type CardLimiteResumoProps = {
  tipoCartao: TipoCartao;
  cartao: any;
  dados: any;
  cardImageUrl?: string | null;
  statusCliente?: string;
};

export function CardLimiteResumo({
  tipoCartao,
  cartao,
  dados,
  cardImageUrl,
  statusCliente,
}: CardLimiteResumoProps) {
  const limiteDisponivel =
    dados?.saldo && statusCliente !== "INADIMPLENTE" ? dados.saldo?.saldo : 0;

  const limiteTotal = dados?.saldo?.limiteCartao ?? 0;

  return (
    <div id="limite-info-container">
      <div
        id="inner-limite-info-container"
        className={tipoCartao === TIPO_CARTAO_CONVENIO ? undefined : "centered"}
      >
        <CardClient
          urlTema={cardImageUrl ?? ""}
          number={
            cartao?.numeroCartao
              ? hiddenCardNumber(cartao.numeroCartao)
              : "**** **** **** ****"
          }
          userName={cartao?.nomeTitular ? String(cartao.nomeTitular) : "--"}
          cardTheme={cartao?.temaDoCartao}
        />

        <LimiteDisponivel
          limiteDisponivel={limiteDisponivel}
          limiteTotal={limiteTotal}
          melhorDiaCompra={dados?.melhorDia ?? 0}
          statusCliente={statusCliente}
          limiteParcelado12xDisponivel={
            tipoCartao === TIPO_CARTAO_TEUCARD
              ? (dados?.saldo?.limiteParcelado12xDisponivel ?? 0)
              : undefined
          }
          tipoCartao={tipoCartao}
          limiteCestaDisponivel={
            tipoCartao === TIPO_CARTAO_CONVENIO
              ? (dados?.saldo?.limiteCestaDisponivel ?? 0)
              : undefined
          }
          limiteCestaTotal={
            tipoCartao === TIPO_CARTAO_CONVENIO
              ? (dados?.saldo?.limiteCesta ?? 0)
              : undefined
          }
          usabilidadeAtivaModalidades={dados?.usabilidadeAtivaModalidades}
        />

        {tipoCartao === TIPO_CARTAO_CONVENIO && <div />}
      </div>
    </div>
  );
}
